import { Component, OnInit } from '@angular/core';
import {BsModalRef, BsModalService} from "ngx-bootstrap/modal";

@Component({
  selector: 'app-requests-help-modal',
  templateUrl: './requests-help-modal.component.pug',
  styleUrls: ['./requests-help-modal.component.scss'],
  standalone: false
})
export class RequestsHelpModalComponent implements OnInit {

  constructor(
    public modalService: BsModalService,
  ) { }

  ngOnInit(): void {
  }

  closeModal(): void {
    this.modalService.hide()
  }
}
